import { Link } from 'react-router-dom';
import { navLinks } from '@/mocks/sports';
import { aboutInfo } from '@/mocks/sports';

const footerLinks = {
  热门分类: navLinks.filter((l) => l.label !== '首页' && l.label !== '关于我们'),
  关于我们: [
    { label: '品牌介绍', href: '/about' },
    { label: '联系我们', href: '/about#contact' },
    { label: '加入我们', href: '/about#join' },
    { label: '网站地图', href: '/sitemap' },
  ],
  帮助中心: [
    { label: '常见问题', href: '/faq' },
    { label: '用户协议', href: '/terms' },
    { label: '隐私政策', href: '/privacy' },
    { label: '免责声明', href: '/disclaimer' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <span className="text-2xl font-heading font-bold text-primary-400">
              bb体育
            </span>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
              bb体育是您首选的专业体育平台，提供全面的体育赛事资讯、实时比分、赛事直播及体育竞技服务。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors text-background-100 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors text-background-100 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors text-background-100 cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-sm font-heading font-semibold text-background-50 mb-4">
                {title}
              </h3>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} {aboutInfo.brandName} 版权所有 | {aboutInfo.contact.address}
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <span>服务热线：{aboutInfo.contact.phone}</span>
            <span>联系邮箱：{aboutInfo.contact.email}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}